<ng-container *ngIf="!!page">
    <tt-gantt [ttRememberId]="'w_captasksview.gantt.' + page.argtype" [(ttOptions)]="gantt"></tt-gantt>
</ng-container>
